import SingleSelect from "components/SingleSelect";
import { FC, useEffect, useState } from "react";
import { DurationInput, DurationPickerWrapper } from "./DurationPicker.styles";
import { DurationPickerProps } from "./types";

export const DurationPicker: FC<DurationPickerProps> = ({
    value,
    label,
    disableUnit,
    handleDurationChange,
    maxLimit = 100,
    tabIndex,
}) => {
    const [currentValue, setCurrentValue] = useState<any>("");
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        const input = Number(e.currentTarget.value);
        if (input > 0 && input <= maxLimit) {
            setCurrentValue(e.currentTarget.value);
            handleDurationChange({
                ...value,
                duration: input,
            });
        } else if (e.currentTarget.value === "") {
            setCurrentValue(e.currentTarget.value);
        }
    };
    useEffect(() => {
        setCurrentValue(value.duration);
    }, [value]);

    return (
        <DurationPickerWrapper>
            <DurationInput
                type="number"
                label={label}
                tabIndex={tabIndex}
                name="duration"
                placeholder="1"
                value={currentValue}
                minWidth="4.5rem"
                onChange={handleInputChange}
            />
            <SingleSelect
                options={[
                    {
                        label: "years",
                        value: "years",
                    },
                    {
                        label: "months",
                        value: "months",
                    },
                    {
                        label: "days",
                        value: "days",
                    },
                ]}
                disabled={disableUnit}
                value={value.unit}
                minWidth="6rem"
                onChange={(unit) =>
                    handleDurationChange({
                        ...value,
                        unit,
                    })
                }
            />
        </DurationPickerWrapper>
    );
};
